var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46967 10.4697C2.17678 10.7626 2.17678 11.2374 2.46967 11.5303C2.76256 11.8232 3.23744 11.8232 3.53033 11.5303L9.25 5.81066V9.6C9.25 10.0142 9.58579 10.35 10 10.35C10.4142 10.35 10.75 10.0142 10.75 9.6V4C10.75 3.58579 10.4142 3.25 10 3.25H4.4C3.98579 3.25 3.65 3.58579 3.65 4C3.65 4.41421 3.98579 4.75 4.4 4.75H8.18934L2.46967 10.4697Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9C17 8.44771 17.4477 8 18 8H20C20.5523 8 21 8.44772 21 9V19C21 19.5523 20.5523 20 20 20H18C17.4477 20 17 19.5523 17 19V9Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12C10.4477 12 10 12.4477 10 13V19C10 19.5523 10.4477 20 11 20H13C13.5523 20 14 19.5523 14 19V13C14 12.4477 13.5523 12 13 12H11Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16C3 15.4477 3.44772 15 4 15H6C6.55228 15 7 15.4477 7 16V19C7 19.5523 6.55228 20 6 20H4C3.44772 20 3 19.5523 3 19V16Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIncrease);
export default __webpack_public_path__ + "static/media/graph-increase.79dd620fb2e28c8b508e265f2ccb4c53.svg";
export { ForwardRef as ReactComponent };